import React from "react";
import { asyncNoop } from "../utils.js";
import { AvailableUsersQuery } from "./AvailableUsersProvider.generated.js";

type AvailableUsersContextType = {
  availableUsers: Extract<
    AvailableUsersQuery["availableUsers"],
    { __typename: "AvailableUsersResult" }
  >["availableUsers"];
  isLoading: boolean;
  /**
   * Whether the identities were actually loaded. A failed or denied query
   * also yields an empty list, which must not pass for a new account.
   */
  hasResult: boolean;
  refetch: () => Promise<unknown>;
};
export const AvailableUsersContext =
  React.createContext<AvailableUsersContextType>({
    availableUsers: [],
    isLoading: false,
    hasResult: false,
    refetch: asyncNoop,
  });
